import { Box, Flex } from '@chakra-ui/react';
import { Row } from '@tanstack/react-table';
import { isEmpty } from 'lodash';
import WebLinks from '~/components/WebLinks';
import { useHover } from '~/screens/MyAgency/hooks/useHover';
import { ICreator } from '~/types';
import { convertPxToRems } from '~/utils-ts';

import { EmptyCell } from './Columns';
import { myAgencyListRowTrackId } from './constants';
import { cellContainer } from './styles';

interface Props {
  row: Row<ICreator>;
}

export const WebLinksCell: React.FC<Props> = ({ row }) => {
  const [hoverElemRef] = useHover<HTMLDivElement>();
  const { webLinks } = row.original;

  return (
    <Box
      ref={hoverElemRef}
      {...cellContainer}
      track-id={myAgencyListRowTrackId.creatorWebLinks}
      width={convertPxToRems(115)}
    >
      {!isEmpty(webLinks) ? (
        <Flex justify="wrap" alignItems="center">
          <WebLinks links={webLinks} />
        </Flex>
      ) : (
        <EmptyCell content="-" />
      )}
    </Box>
  );
};
